export default __webpack_public_path__ + "static/media/brain.eecb8c7d.svg";